import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { Capacitor } from '@capacitor/core';
import * as StackTrace from 'stacktrace-js';

@Injectable({ providedIn: 'root' })
export class CrashlyticsService {
  constructor(private readonly router: Router) {
    this.trackPageChanges();
  }

  public async setUserId(userId: string) {
    if (Capacitor.isNativePlatform()) {
      await FirebaseCrashlytics.setUserId({ userId });
    }
  }

  public async unsetUserId() {
    await this.setUserId('');
  }

  public async ensureEnabled() {
    if (Capacitor.isNativePlatform()) {
      await FirebaseCrashlytics.setEnabled({ enabled: true });
    }
  }

  public setPageName(name: string): void {
    if (Capacitor.isNativePlatform()) {
      FirebaseCrashlytics.setCustomKey({
        key: 'page',
        value: name,
        type: 'string',
      }).then();
    }
  }

  public sendStackTrace(error: Error) {
    if (Capacitor.isNativePlatform()) {
      StackTrace.fromError(error)
        .then(st => {
          return FirebaseCrashlytics.recordException({
            message: error.message,
            stacktrace: st,
          });
        })
        .catch(() => {
          console.warn('Unparsable', error);
        })
        .then(() => FirebaseCrashlytics.sendUnsentReports());
    }
  }

  public log(message: string) {
    if (Capacitor.isNativePlatform()) {
      FirebaseCrashlytics.log({ message }).then();
    }
  }

  private trackPageChanges() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentPage = event.urlAfterRedirects;
        this.log(`Navigated to ${currentPage}`);
        this.setPageName(currentPage);
      }
    });
  }
}
